import { memo } from "react"

interface SkeletonProps {
	className?: string
}

/**
 * Base skeleton component for loading states in dark-themed admin UI.
 * Uses gray-700 background to match admin theme.
 */
export const Skeleton = memo(function Skeleton({ className = "" }: SkeletonProps) {
	return (
		<div
			aria-busy="true"
			aria-live="polite"
			className={`animate-pulse rounded bg-gray-700 ${className}`}
		>
			<span className="sr-only">Loading...</span>
		</div>
	)
})
